import { Link } from "react-router-dom";

interface ArticleCardProps {
  slug: string;
  title: string;
  description: string;
  categoryName: string;
  date: string;
  readTime: number;
}

export default function ArticleCard({
  slug,
  title,
  description,
  categoryName,
  date,
  readTime,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 transition-all duration-200 hover:border-primary-200/60 group cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="flex items-center gap-3 mb-3">
          <span className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium whitespace-nowrap">
            {categoryName}
          </span>
          <span className="text-xs text-foreground-400">{date}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-400">{readTime} 分钟阅读</span>
        </div>
        <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
          {description}
        </p>
        <div className="mt-4 flex items-center gap-1 text-sm text-primary-500 font-medium">
          阅读全文
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </div>
      </Link>
    </article>
  );
}